import { track } from "./core";
import { ICheckTool } from "./interfaces/ICheckTool";

export function check_tool(checkData: ICheckTool) {
	track(
		{
			'event': checkData.event || 'check_tool',
			'check_name': checkData.check_name,
			'check_question_name': checkData.check_question_name,
			'check_question_state': checkData.check_question_state,
			'check_call': checkData.check_call
		}
	)
}

